function installDjurliganProductAutoplay(sectionId) {
  const SECTION_ID = sectionId;
  const AUTOPLAY_TIME = 10000;
  function initDjurliganProductAutoplay() {
    const section = document.getElementById(SECTION_ID);
    if (!section) return;
    if (section.dataset.djurliganAutoplay === 'true') return;
    const reducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (reducedMotion || (connection && connection.saveData)) {
      section.dataset.djurliganAutoplay = 'reduced';
      return;
    }
    const slider = section.querySelector('.l4cl.slider');
    if (!slider) return;
    const products = Array.from(slider.children);
    if (products.length <= 6) return;
    let timer = null;
    let paused = false;
    let inViewport = !('IntersectionObserver' in window);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inViewport = entries[0].isIntersecting;
        if (inViewport) startAutoplay();
        else clearInterval(timer);
      }, { rootMargin: '100px 0px' }).observe(section);
    }
    function visible(element) {
      if (!element) return false;
      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.width > 0 &&
        rect.height > 0
      );
    }
    function findControls() {
      const ownNext = slider.querySelector('.swiper-button-next');
      const ownPrevious = slider.querySelector('.swiper-button-prev');
      if (ownNext && ownPrevious) {
        return { nextButton: ownNext, previousButton: ownPrevious };
      }
      const allControls = Array.from(
        section.querySelectorAll(
          'button, a, [role="button"]'
        )
      );
      let nextButton = allControls.find(function (element) {
        if (slider.contains(element)) return false;
        if (!visible(element)) return false;
        const info = [
          element.getAttribute('aria-label') || '',
          element.getAttribute('title') || '',
          element.className || '',
          element.textContent || ''
        ]
          .join(' ')
          .toLowerCase();
        return (
          info.includes('next') ||
          info.includes('nästa') ||
          info.includes('forward') ||
          info.includes('arrow-right') ||
          info.includes('right')
        );
      });
      let previousButton = allControls.find(function (element) {
        if (slider.contains(element)) return false;
        if (!visible(element)) return false;
        const info = [
          element.getAttribute('aria-label') || '',
          element.getAttribute('title') || '',
          element.className || '',
          element.textContent || ''
        ]
          .join(' ')
          .toLowerCase();
        return (
          info.includes('previous') ||
          info.includes('prev') ||
          info.includes('föregående') ||
          info.includes('arrow-left') ||
          info.includes('left')
        );
      });
      if (!nextButton || !previousButton) {
        const sliderRect = slider.getBoundingClientRect();
        const candidates = allControls
          .filter(function (element) {
            if (slider.contains(element)) return false;
            if (!visible(element)) return false;
            const rect = element.getBoundingClientRect();
            return (
              rect.bottom <= sliderRect.top + 40 &&
              rect.top >=
                section.getBoundingClientRect().top
            );
          })
          .sort(function (a, b) {
            return (
              a.getBoundingClientRect().left -
              b.getBoundingClientRect().left
            );
          });
        if (candidates.length >= 2) {
          previousButton =
            previousButton ||
            candidates[candidates.length - 2];
          nextButton =
            nextButton ||
            candidates[candidates.length - 1];
        }
      }
      return {
        nextButton,
        previousButton
      };
    }
    function isDisabled(element) {
      if (!element) return true;
      return (
        element.disabled === true ||
        element.getAttribute('disabled') !== null ||
        element.getAttribute('aria-disabled') === 'true' ||
        element.classList.contains('disabled')
      );
    }
    function returnToBeginning(previousButton) {
      const swiperRoot = slider.querySelector('.swiper-outer');
      const swiper = swiperRoot && swiperRoot.swiper;
      if (swiper && typeof swiper.slideTo === 'function' && !swiper.destroyed) {
        swiper.slideTo(0, 350);
        return;
      }
      if (!previousButton) return;
      let clicks = 0;
      const backTimer = setInterval(function () {
        if (
          isDisabled(previousButton) ||
          clicks >= 10
        ) {
          clearInterval(backTimer);
          return;
        }
        previousButton.click();
        clicks++;
      }, 250);
    }
    function nextProducts() {
      // Stop timers for Shopify sections removed during dynamic navigation/editor updates.
      if (!section.isConnected) { clearInterval(timer); return; }
      if (paused || document.hidden || !inViewport || slider.querySelector('form.dj-card-quantity[data-quantity-open="true"]')) return;
      if (window.matchMedia('(max-width: 759px)').matches &&
          slider.classList.contains('djurligan-featured-products') &&
          !slider.classList.contains('s4wi')) {
        const max = slider.scrollWidth - slider.clientWidth;
        if (max <= 2) return;
        const firstCard = slider.querySelector(':scope > li');
        const step = (firstCard ? firstCard.getBoundingClientRect().width : 165) + 10;
        const left = slider.scrollLeft >= max - 5 ? 0 : Math.min(max, slider.scrollLeft + step * 2);
        try { slider.scrollTo({ left: left, behavior: 'smooth' }); }
        catch (error) { slider.scrollLeft = left; }
        return;
      }
      const controls = findControls();
      const nextButton = controls.nextButton;
      const previousButton = controls.previousButton;
      if (!nextButton) {
        console.log(
          'Djurligan autoplay: högerpilen kunde inte hittas.'
        );
        return;
      }
      if (!isDisabled(nextButton)) {
        nextButton.click();
        return;
      }
      returnToBeginning(previousButton);
    }
    function startAutoplay() {
      clearInterval(timer);
      if (!section.isConnected || paused || document.hidden || !inViewport) return;
      timer = setInterval(function () {
        nextProducts();
      }, AUTOPLAY_TIME);
    }
    slider.addEventListener(
      'mouseenter',
      function () {
        paused = true;
        clearInterval(timer);
      }
    );
    slider.addEventListener(
      'mouseleave',
      function () {
        paused = false;
        startAutoplay();
      }
    );
    // Avoid moving a carousel while the shopper is touching or swiping it.
    let touchResumeTimer = null;
    slider.addEventListener('touchstart', function () {
      paused = true;
      clearInterval(timer);
      clearTimeout(touchResumeTimer);
    }, { passive: true });
    function resumeAfterTouch() {
      clearTimeout(touchResumeTimer);
      touchResumeTimer = setTimeout(function () {
        paused = false;
        startAutoplay();
      }, 12000);
    }
    slider.addEventListener('touchend', resumeAfterTouch, { passive: true });
    slider.addEventListener('touchcancel', resumeAfterTouch, { passive: true });
    section.addEventListener(
      'click',
      function (event) {
        const control = event.target.closest(
          'button, [role="button"]'
        );
        if (!control) return;
        startAutoplay();
      }
    );
    document.addEventListener(
      'visibilitychange',
      function () {
        startAutoplay();
      }
    );
    section.dataset.djurliganAutoplay = 'true';
    startAutoplay();
  }
  initDjurliganProductAutoplay();
}
function initDjurliganCarousels(root) {
  root.querySelectorAll('.djurligan-featured-products.slider').forEach(function (slider) {
    const section = slider.closest('[id^="shopify-section-"]');
    if (section) installDjurliganProductAutoplay(section.id);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { initDjurliganCarousels(document); }, { once: true });
} else {
  initDjurliganCarousels(document);
}
document.addEventListener('shopify:section:load', function (event) { initDjurliganCarousels(event.target); });

